import { render } from "./SavePersonaModal.vue?vue&type=template&id=038126a8&scoped=true"
import script from "./SavePersonaModal.vue?vue&type=script&lang=js"
export * from "./SavePersonaModal.vue?vue&type=script&lang=js"

import "./SavePersonaModal.vue?vue&type=style&index=0&id=038126a8&lang=scss&scoped=true"
import "./SavePersonaModal.vue?vue&type=style&index=1&id=038126a8&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038126a8"]])

export default __exports__